import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const LinkContext = /*#__PURE__*/createContext(undefined);
export const LinkProvider = ({
  use,
  disabled,
  iconStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(LinkContext.Provider, {
    value: {
      use,
      disabled,
      iconStyleOverrides
    },
    children: children
  });
};
export const useLinkContext = () => {
  return useContext(LinkContext);
};